<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="applyDialogVisible"
        center
        class="detail-dialog-container"
        width="1056px">
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">会员管理制度</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-direction">
                <div v-for="(item,index) in managements" :key="index" class="collapse flex flex-direction">
                    <div class="title-container flex align-center justify-between"
                         @click="managementChange(index)">
                        <div class="title">{{ item.typeName }}</div>
                        <i :class="item.expand ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="arrow"></i>
                    </div>
                    <div v-if="item.expand" class="flex flex-direction ">
                        <div v-for="(child,position) in item.list"
                             :key="position" class="content"
                             @click="onItem(child)">
                            {{ child.title }}
                        </div>
                        <div v-if="item.list.length === 0" class="more margin-top-sm self-center">暂无数据</div>
                    </div>
                </div>
            </div>
        </div>
        <more-management-detail-dialog :id="cur_id" :apply-dialog-visible="detailDialogVisible"
                                       :title="cur_title" @watchState="watchState">
        </more-management-detail-dialog>
    </el-dialog>
</template>

<script>

import {getMemberManagement} from "@/api/data";
import MoreManagementDetailDialog from "./MoreManagementDetailDialog";

export default {
    name: "MoreManagementDialog",
    components: {MoreManagementDetailDialog},
    props: {
        applyDialogVisible: {
            type: Boolean,
            default: false
        },
        oid: { //详情ID
            type: Number,
        }
    },
    data() {
        return {
            managements: [],
            page: 1,
            limit: 10,
            total: 0,
            cur_id: 0,
            cur_title: '',
            detailDialogVisible: false
        }
    },
    created() {
        if (this.oid) this.init()
    },
    methods: {
        async init() {
            let _data = await getMemberManagement(this.oid, 1, 1000)
            _data.data.map((item, index) => {
                item.expand = index === 0
            })
            this.managements = _data.data
            this.total = _data.total_number
        },
        managementChange(position) {
            this.managements.map((item, index) => {
                if (index === position) {
                    item.expand = !item.expand
                } else {
                    item.expand = index === position
                }
            })
        },
        cancel() {
            this.$emit('watchState', false)
        },
        onItem(item) {
            this.cur_id = item.id
            this.cur_title = item.title
            this.detailDialogVisible = true
        },
        watchState() {
            this.detailDialogVisible = false
        }
    },
    watch: {
        oid() {
            if (this.oid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-dialog-container {
    .dialog-container {
        background-color: #101d48;

        .dialog-header {
            height: 55px;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #ffffff;
                text-align: center;
            }

            .dialog-close {
                font-size: 21px;
                color: #ffffff;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            height: 505px;
            padding: 0 20px;
            overflow-y: scroll;

            &::-webkit-scrollbar {
                background: transparent;
                width: 2px;
            }

            &::-webkit-scrollbar-thumb {
                background: #ffffff;
            }

            .collapse {
                .title-container {
                    height: 50px;
                    border-bottom: 1px solid #30407e;
                    margin-top: 10px;
                    cursor: pointer;

                    .title {
                        padding: 0 17px;
                        font-size: 18px;
                        color: #0ddaff;
                        position: relative;

                        &:after {
                            position: absolute;
                            content: '';
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 5px;
                            height: 21px;
                            background-color: #0ddaff;
                            border-radius: 3px;
                        }
                    }

                    .arrow {
                        color: #0ddaff;
                    }
                }

                .content {
                    font-size: 16px;
                    color: #ffffff;
                    cursor: pointer;
                    margin-top: 13px;
                }

                .more {
                    font-size: 16px;
                    color: #ffffff;
                }
            }
        }
    }
}
</style>